<template>
  <div>
    <VBox :scrollable="true">
    <b-container fluid>
      <b-row>
        <b-col>
            <b-container class="pt-4">
              <b-row>
                <b-col>
                  <b-form-group>
                    <slot name="label">
                      {{$tr('importDataToGrid.slot.Season','Season')}}
                    </slot>
                    <div class="input-group">
                      <div class="form-control grey-label readonly-input">
                        <div v-html="seasonName"></div>
                      </div>
                      <b-button
                          data-test-path="tree-select-button"
                          class="form-button ml-1 d-none d-xl-inline-block"
                          variant="plm-action"
                          :disabled="readOnly"
                          @click="selectSeason"
                      >
                        <font-awesome-icon icon="pencil-alt" class="mr-2"/>
                        {{$tr('button.Select','Select')}}
                      </b-button>
                      <b-button
                          class="form-button-icon ml-1 d-xl-none"
                          variant="plm-action"
                          :disabled="readOnly"
                          @click="selectSeason"
                      >
                        <font-awesome-icon icon="pencil-alt" class="mr-2"/>
                      </b-button>
                    </div>
                    <small v-if="!selectedSeasonId" class="form-text text-danger" style="margin-top: 2px; margin-left: 10px;">
                      {{$tr('importDataToGrid.season.field.empty',"Season FIELD can't be empty")}}
                    </small>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group>
                    <slot name="label">
                      &nbsp;
                    </slot>
                    <FileUpload
                        ref="importDataUpload"
                        data-test-path="import-data-upload"
                        @file-selected="importDataFileSelected"
                        :read-only="!selectedSeasonId"
                    >
                    </FileUpload>
                  </b-form-group>
                  <div class="text-center" v-if="loading">
                    <span>{{ percentDone }} %</span>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="pt-4" v-if="!allBugs.length && numberOfImportedRecords !== 0  && fileIsReady" data-test-path="file-upload-info">
                  {{$tr('importDataToGrid.successfuly.loaded.file','The file has been loaded successfully.')}}
                  <div>{{numberOfImportedRecords}} {{$tr('importDataToGrid.records.imported','records have been imported.')}}</div>
                </b-col>
                <b-col class="pt-4" v-if="!allBugs.length && numberOfImportedRecords === 0  && fileIsReady"></b-col>
                <b-col class="pt-4" v-if="!allBugs.length && numberOfImportedRecords === 0  && fileIsReady">
                  {{$tr('importDataToGrid.Warnings','Warnings')}}: <br>
                  {{$tr('importDataToGrid.no.data.to.import','No data to import have been found.')}}
                </b-col>
                <b-col class="pt-4" v-if="allBugs.length">
                  {{$tr('importDataToGrid.errors','Errors')}}:
                  <b-container>
                    <b-row  v-for="bug of allBugs" :key="bug.id">
                      {{bug}}
                    </b-row>
                  </b-container>
                </b-col>
              </b-row>
            </b-container>
        </b-col>
      </b-row>
    </b-container>
    </VBox>
    <FooterNavbar data-test-path="import-data-to-grid-footer">
      <CloseButton @close="close"></CloseButton>
    </FooterNavbar>
  </div>
</template>
<script>

import Activity from "@/activity/Activity";
import FileUpload from "@/components/FileUpload";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import CloseButton from "@/components/navbar/CloseButton";
import VBox from "@/components/VBox";
import moment from "moment-timezone";
import DialogManager from "@/utils/DialogManager";
import FormsActions from "@/components/forms/FormsActions";
import Season from "@/server/com/silkplm/model/plm/Season";

moment.suppressDeprecationWarnings = true;

export default {
  name: "ImportDataToGrid",
  components: {CloseButton, FooterNavbar, FileUpload, VBox},


  async mounted() {
    this.userLocale = window.navigator.language;
  },

  methods: {

    ...Activity.methods,

    getTitle() {
      return $tr('importDataToGrid.import.budgeting.planner','Import to budgeting planner"');
    },

    async selectSeason() {
      this.listSeasons = await this.refreshSeasons();

      let result = await (await FormsActions.showSelectList(Season)).getResult();
      if (result) {
        this.selectedSeasonId = result.id;
        let selectedSeasonName = result.season;
        if (this.selectedSeasonId) {
          this.seasonName = selectedSeasonName;
        }
      }
    },

    async refreshSeasons() {
      let listSeasons = await Rpc.plm.services.BudgetingPlannerService.listSeasons().lock();
      for (let i = 0; i < listSeasons?.length; i++) {
        if(listSeasons[i].startDate?.value){
          let startDate = moment(listSeasons[i].startDate.value);
          listSeasons[i].startDate = startDate.locale(this.userLocale).format("L");
        }
        if(listSeasons[i].endDate?.value){
          let endDate = moment(listSeasons[i].endDate.value);
          listSeasons[i].endDate = endDate.locale(this.userLocale).format("L");
        }
      }
      return listSeasons;
    },

    async importDataFileSelected() {
      let fileUpload = this.$refs.importDataUpload;
      let file = fileUpload.getFile();
      this.loading = true;
      fileUpload.setProgress(0);
      try {
        let res = await Rpc.plm.DataImport.importDataToBudgetingPlanner(file, this.selectedSeasonId).lock().onProgress((e) => {
          fileUpload.setProgress(e.percent);
          this.percentDone = Math.floor(e.percent);
        });
        this.allBugs = res.bugs;
        this.numberOfImportedRecords = res.numberOfImportedRecords;
        this.fileIsReady = true;
        this.loading = false;
        this.percentDone = 0;
        fileUpload.reset();
      } catch (e) {
        this.loading = false;
        this.percentDone = 0;
        if (e instanceof RpcInputValidationException) {
          fileUpload.setError(e.fields.$field.errorMessage);
          this.allBugs = 0;
          this.fileIsReady = false;
        }
      }
      if(this.allBugs?.length){
        await DialogManager.info($tr('importDataToGrid.error.import.file','File import error'),
            $tr('importDataToGrid.info.contains.errors','The file cannot be imported because it contains errors.'));
      }
    }

  },

  props: {},

  data: () => ({
    userLocale: null,
    listSeasons: [],
    allBugs: [],
    fileIsReady: false,
    loading: false,
    percentDone: 0,
    numberOfImportedRecords: 0,
    seasonName: null,
    selectedSeasonId: null,
    season: null,
    readOnly: false,
    seasonFields: [
      {name: 'Season', prop: 'season', sortable: true, size: 200},
      {name: 'Start date', prop: 'startDate', sortable: true, size: 200},
      {name: 'End date', prop: 'endDate', sortable: true, size: 200},
    ],
  }),

}
</script>
